export default __webpack_public_path__ + "static/media/logo_loyalty.12892a08.png";